import { useInView } from "react-intersection-observer";
import { useNavigate } from "react-router-dom";

export const useHookUpdateUrlArticle = (urlPath: string) => {
  const navigate = useNavigate();

  const { ref } = useInView({
    threshold: 0.1,
    onChange: (inView) => {
      if (inView) navigate(urlPath, { preventScrollReset: true });
    },
  });

  return { ref };
};
